// extracted by mini-css-extract-plugin
module.exports = {"title":"SuccessModal_title__3HydW","container":"SuccessModal_container__wBOh-","subtitle":"SuccessModal_subtitle__3SLPI","button":"SuccessModal_button__3Q3TA"};